[
    "albumin",
    "albumin",
    "aldioxa",
    "allantoin",
    "alphahydroxysäuren",
    "alpha-hydroxysäuren",
    "alpha-hydroxysäuren",
    "aminosäuren",
    "aminosäuren",
    "aminosuccinatsäure",
    "ammoniumhydrolysiertes protein",
    "asparaginsäure",
    "aspik",
    "beta-karotin",
    "biotin",
    "benzoesäure",
    "borste",
    "kalziumkarbonat",
    "kalziumhydroxid",
    "kalziumlaktat",
    "kalziumoxid",
    "kalziumphosphat",
    "kalziumstearat",
    "caprylbetain",
    "caprylaminoxid",
    "caprylsäure",
    "kohlenschwarz",
    "cetylalkohol",
    "cetylether",
    "cetylpalmitat",
    "cetylalkohol",
    "cetylpalmitat",
    "kreide",
    "kohle",
    "chitin",
    "cholecalciferol",
    "chymosin",
    "farbe",
    "farben",
    "zibet",
    "kortikosteroid",
    "kortikosteroid",
    "cortison",
    "cortison kortikosteroid",
    "dexpanthenol",
    "diglyzeride",
    "dinatriuminosinat",
    "farbstoff",
    "farbstoffe",
    "e129",
    "e133",
    "e170",
    "e322",
    "e470",
    "e570",
    "e585",
    "e631",
    "e640",
    "e901",
    "e910",
    "e920",
    "enzyme",
    "ergocalciferol",
    "estradiol",
    "fette",
    "fd-und-c-farben",
    "fd&c-farben",
    "filz",
    "gluconolacton",
    "glucosamin",
    "glutaminsäure",
    "glyzeride",
    "glyzerin",
    "glyzin",
    "glykogen",
    "hydrocortison",
    "inositol",
    "insulin",
    "isopropylmyristat",
    "l-milchsäure",
    "milchsäure",
    "lecithin",
    "leucin",
    "linolsäure",
    "lipide",
    "lipoide",
    "lysin",
    "mono-und diglyzeride",
    "mono-diglyzeride",
    "monoglyzeride",
    "monoglyzeridglyzeride",
    "mononatriumglutamat",
    "msg",
    "moschus",
    "moschusöl",
    "myristalethersulfat",
    "myristinsäure",
    "natürlicher geschmack",
    "natürliche aromen",
    "natürliche quellen",
    "nukleinsäuren",
    "nukleinsäuren",
    "octyldodekanol",
    "östrogen",
    "öle",
    "ölsäure",
    "ölsäure",
    "oleylalkohol",
    "oleinsäureöl",
    "oleth",
    "oleylmyristat",
    "palmitamid",
    "palmitamin",
    "palmitat",
    "palmitinsäure",
    "panthenol",
    "panthenyl",
    "polysorbate",
    "polypeptide",
    "kaliumlaktat",
    "progesteron",
    "propylenglykol",
    "provitamin a",
    "provitamin b-5",
    "provitamin d-2",
    "chinolingelb",
    "rot 40",
    "lab",
    "rennin",
    "ribonukleinsäure",
    "rns",
    "saccharidhydrolysat",
    "sorbitanbienenwachs",
    "sorbitanmonooleat",
    "sorbitanmonostearat",
    "sorbitantrioleat",
    "sorbitantristearat",
    "schwamm",
    "squalan",
    "squalen",
    "stearamid",
    "stearamin",
    "stearaminoxid",
    "stearat",
    "stearate",
    "stearinsäure",
    "stearinhydrazid",
    "stearinsäure",
    "stearin",
    "stearon",
    "stearoxytrimethylsilan",
    "stearoyllactylsäure",
    "stearylacetat",
    "stearylalkohol",
    "stearylalkohol sterole",
    "stearylbetain",
    "stearylcaprylat",
    "stearylcitrat",
    "stearylglycyrrhetinat",
    "stearylheptanoat",
    "stearylimidazolin",
    "stearyloctanoat",
    "stearylstearat",
    "stearyltartrat",
    "stearyltartrat",
    "steroid",
    "sterol",
    "wildleder",
    "talg",
    "sunset gelb fcf",
    "tartrazin",
    "taurin",
    "testosteron",
    "threonin",
    "pergament",
    "samt",
    "vitamin a",
    "vitamin b",
    "vitamin-b-komplex-faktor",
    "vitamin b1",
    "vitamin b12",
    "vitamin d3",
    "vitamin h",
    "gelb5",
    "gelb6"
]